var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',{staticClass:"picture-atom"},[_c('source',{attrs:{"srcset":_vm.src,"type":"image/webp"}}),_vm._v(" "),_c('EsyImg',{attrs:{"src":_vm.fallbackSrc,"alt":_vm.alt,"width":_vm.width,"height":_vm.height,"loading":_vm.loading,"showItemprop":_vm.showItemprop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }